"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cart = void 0;
var Cart = /** @class */ (function () {
    function Cart(_a, storage) {
        var id = _a.id, subtotal = _a.subtotal, currency = _a.currency, items = _a.items;
        this.id = id;
        this.subtotal = subtotal;
        this.currency = currency;
        this.items = items;
        this.storage = storage;
    }
    Cart.prototype.hasNewItem = function (cart) {
        return cart.items.length > this.items.length;
    };
    Cart.prototype.current = function () {
        return {
            id: this.id,
            subtotal: this.subtotal,
            currency: this.currency,
            items: this.items
        };
    };
    Cart.prototype.update = function (_a) {
        var id = _a.id, subtotal = _a.subtotal, currency = _a.currency, items = _a.items;
        this.id = id;
        this.subtotal = subtotal;
        this.currency = currency;
        this.items = items;
        this.storeCart({ id: id, subtotal: subtotal, currency: currency, items: items });
    };
    /**
     *
     * Diff includes quantity
     *
     * //TODO We dont need this currently. finalize the approach for the diffs
     *
     */
    Cart.prototype.diff = function (cart) {
        var _this = this;
        var result = {
            added: [],
            changed: [],
            removed: []
        };
        cart.items.forEach(function (nextProduct) {
            var prevProduct = _this.items.find(function (p) { return p.id === nextProduct.id; });
            if (!prevProduct)
                result.added.push(nextProduct);
            if (prevProduct && prevProduct.quantity !== nextProduct.quantity) {
                result.changed.push({ prev: prevProduct, next: nextProduct });
            }
        });
        /**
         * Do we really need to track what has been removed ?
         */
        this.items.forEach(function (prevProduct) {
            var nextProduct = cart.items.find(function (p) { return p.id === prevProduct.id; });
            if (!nextProduct)
                result.removed.push(prevProduct);
        });
        return result;
    };
    Cart.empty = function () {
        return {
            id: '',
            subtotal: 0,
            currency: '',
            items: []
        };
    };
    Cart.prototype.storeCart = function (cart) {
        this.storage.set('cart', cart);
    };
    return Cart;
}());
exports.Cart = Cart;
//# sourceMappingURL=data:application/json;base64,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